import { forwardRef, type PropsWithChildren } from "react";

import { IconButton, type IconButtonProps } from "./icon-button";

export const NoticeIconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Omit<IconButtonProps, "variant">>
>(({ children, ...props }, ref) => {
  return (
    <IconButton ref={ref} variant="notice" {...props}>
      {children}
    </IconButton>
  );
});
